<template>
    <!-- :card-data="data" -->
  <card-template
    :card-title="data.cardName"
    :is-loading="isLoading"
    :card-info="getCardInfo()"
    card-type="DATABASE"
  ></card-template>
</template>

<script>
import CardTemplate from './card-template.vue'
import supervisorStorge from '../../storage/supervisorStorage'

export default {
  name: 'card-database',
  methods: {
    getCardInfo () {
      const correct = supervisorStorge.getDatabaseCorrectLogs()
      const total = supervisorStorge.getSupervisorFtpFiles().length
      const incorrect = total - correct

      const percentageCorrect = correct / total
      if (this.isLoading) {
        return {
          lightColor: 'gray',
          cardNumber: 0,
          message: 'Verificando archivos'
        }
      }
      if (percentageCorrect === 1) {
        return {
          lightColor: 'green',
          cardNumber: 0,
          message: 'Correcto, todos los logs de la base de datos son correctos'
        }
      } else if (percentageCorrect > 0.9) {
        return {
          lightColor: 'amber',
          cardNumber: incorrect,
          message: `de ${total} distribuidora(s) tiene(n) errores en BD`
        }
      } else {
        return {
          lightColor: 'red',
          cardNumber: incorrect,
          message: `de ${total} distribuidora(s) tiene(n) errores en BD`
        }
      }
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      default () {
        return true
      }
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    CardTemplate
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/supervisor/card-database.vue